
const defaultState = {
  query: '',
  result: [],
  selected: null,
  searchResults: [],
  hasMoreEntries: false,
  loading: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SEARCH_TYPE_AHEAD_BEGIN':
      return { ...state, query: action.payload.query }
    case 'SEARCH_TYPE_AHEAD_SUCCESS':
      return { ...state, result: action.payload }
    case 'SEARCH_TYPE_AHEAD_SELECT':

      let selected = state.result.find((r) => `${r.documentTypeId}_${r.id}` === action.payload)
      return { ...state, query: selected.title, selected };

    case 'SEARCH_SELECTED_CLEAR':
      return { ...state, selected: null, result: [] }
    case 'SEARCH_RESULT_BEGIN':
      return { ...state, loading: true, searchResults: [] }
    case 'SEARCH_RESULT_SUCCESS':
      return { ...state, query: action.payload.query, loading: false, searchResults: action.payload.entries, hasMoreEntries: action.payload.hasMoreEntries }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/search/searchReducer.js